'use client';

import * as React from 'react';

import { Button } from '@workspace/ui/components/button';
import { ThemeToggle } from '@workspace/ui/components/theme-toggle';

import { MobileMenu } from '~/components/mobile-menu';
import { setUserMetadata } from '~/lib/openreplay';
import { getUserId, setUserId } from '~/lib/user-id';

export function Navbar(): React.JSX.Element {
  const handleSignUpClick = () => {
    // Simulate signup flow
    // In a real app, this would happen after the signup form submission
    const userId = getUserId(); // Get current UUID (already exists from OpenReplay init)

    // Mock: User signs up, backend receives this UUID and stores it as userId
    // The UUID is already being tracked in OpenReplay
    // Now we just add additional metadata
    setUserMetadata({
      userId, // Keep the same UUID
      email: 'rbutta@gmail.com',
      name: 'Rodri New User',
      accountType: 'authenticated',
      signedUpAt: new Date().toISOString(),
      userType: 'authenticated'
    });

    console.log('Signup: User registered with UUID:', userId);
  };

  const handleSignInClick = () => {
    // Simulate signin flow with mock user from database
    const currentStoredId = getUserId(); // Get currently stored UUID

    // Mock: Simulate API response from database after successful login
    const mockUserFromDatabase = {
      id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890', // UUID stored in database
      email: 'rbutta@gmail.com',
      name: 'Rodri Existing User',
      accountType: 'authenticated',
      signedUpAt: '2024-01-15T10:30:00.000Z'
    };

    // Check if the stored UUID is different from the one in database
    if (currentStoredId !== mockUserFromDatabase.id) {
      console.log(
        'Sign in: UUID mismatch - updating stored UUID from',
        currentStoredId,
        'to',
        mockUserFromDatabase.id
      );
      // Overwrite localStorage with the UUID from database
      // This ensures consistency for users created outside our project
      setUserId(mockUserFromDatabase.id);
    }

    // Update OpenReplay metadata with authenticated user info
    setUserMetadata({
      userId: mockUserFromDatabase.id, // Use UUID from database
      email: mockUserFromDatabase.email,
      name: mockUserFromDatabase.name,
      accountType: mockUserFromDatabase.accountType,
      signedUpAt: mockUserFromDatabase.signedUpAt,
      userType: 'authenticated'
    });

    console.log('Sign in: User logged in with UUID:', mockUserFromDatabase.id);
  };
  return (
    <section className="sticky inset-x-0 top-0 z-40 border-b bg-background py-4">
      <div className="container">
        <nav className="hidden justify-between lg:flex">
          <div className="flex items-center gap-2">
            <ThemeToggle className="rounded-xl border-none shadow-none" />
            <Button
              variant="outline"
              onClick={handleSignInClick}
              className="rounded-xl"
            >
              Mock login
            </Button>
            <Button
              variant="default"
              onClick={handleSignUpClick}
              className="rounded-xl"
            >
              Mock registro
            </Button>
          </div>
        </nav>
        <MobileMenu className="lg:hidden" />
      </div>
    </section>
  );
}
